import hash = require("object-hash");
import _ = require("lodash");
import { CellType, ExcelColorValue, UploadStatus, Constants, ColumnType } from "../../util/UIConstants";
import { IColumnConfig } from "../configuration";
import { currentResource, labels } from "../../util/utils";
import Utility from "../../util/utilityFunctions";
import { TemplateUIExcelInterface } from "../../services/template/TemplateUIExcelInterface";

export class EditTaskConfiguration implements IColumnConfig {
  columns: any[];
  rowheader: any[];

  constructor() {
    this.columns = [
      {
        CellHeader: labels.status,
        CellId: "UploadStatus",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return `${currentResource.uploadStatusLabels[UploadStatus.Downloaded]}`;
        },
      },
      {
        CellHeader: labels.updateCanvas,
        IsMarkValue: true,
        CellId: "MarkForUpdate",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
        },
        getCellData: (data) => {
          return Constants.MarkForUpdateNo;
        },
        referenceData: {
          getCellData: (data) => {
            return Utility.updateEYCanvasDropDownValues;
          },
        },
        cellToBindDropDown: true,
      },
      {
        CellHeader: labels.prefix,
        CellId: "Prefix",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          return data.taskNamePrefix;
        },
      },
      {
        CellHeader: labels.requiredTitle,
        CellId: "RequiredTitle",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          requiredColumnWidth: 278.27, //50 Width
          disableDefaultFormatting: true,
          wrapText: true,
          lockedCondition: (data) => !data.isTaskNameEditable,
        },
        getCellData: (data) => {
          return data.isTaskNameEditable ? data.name : data.knowledgeTaskTitle;
        },
      },
      {
        CellHeader: labels.suffix,
        CellId: "Suffix",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          return data.taskNameSuffix;
        },
      },
      {
        CellHeader: labels.timePhaseRequired,
        CellId: "TimePhaseRequired",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "TimePhaseRequiredreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "C",
          referenceDataCellNameEndAddress: "F",
          referenceDataCellRowStartIndex: 5,
          referenceDataCellRowIndexMax: 1000,
          outputDataattributes: ["value", "startDate", "endDate", "id"],
        },
        CellFormat: {
          locked: false,
          requiredColumnWidth: 140.93, //25 Width
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data) => {
          return data?.periodName;
        },
      },
      {
        CellHeader: labels.taskGroupRequired,
        CellId: "TaskGroupRequired",
        cellToBindDropDown: true,
        referenceData: {
          sourceDataObjectName: "TaskGroupRequiredreferenceData",
          showDynamicDropdown: false,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "H",
          referenceDataCellNameEndAddress: "J",
          referenceDataCellRowStartIndex: 5,
          referenceDataCellRowIndexMax: 1000,
          outputDataattributes: ["value", "groupName", "id"],
        },
        CellFormat: {
          lockedCondition: (data) => data.typeId !== 13,
          locked: false,
          requiredColumnWidth: 140.93, //25 Width
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const taskSectionId = data?.taskSectionId;

          const matchingGroup = referenceData?.taskGroups?.find((group) => group[2] == taskSectionId);
          return matchingGroup ? matchingGroup[0] : "";
        },
        validateImpactedCells: (updatedValue, validateRule, rowData, referenceData, rowInputPayload) => {
          let validationMessage = null;
          const errorDetails = {
            errorCode: 5202,
            defaultMessage: "Cannot change task group",
          };

          const taskGroupEditSupportedTaskTypes = [12,13];
          
          const impactedCellDetailTaskGroup = this.columns.find((x) => x.CellId == "originalTaskGroup");
          let  originalValueTaskGroup = rowData[impactedCellDetailTaskGroup.CellDisplayIndex];
          const impactedCellDetail = this.columns.find((x) => x.CellId == "taskType");
          let updatedValueImpactedCell = rowData[impactedCellDetail.CellDisplayIndex];
            const taskTypeId = +Object.keys(currentResource.taskTypeAbbreviation)
              .find((key) => currentResource.taskTypeAbbreviation[key] == updatedValueImpactedCell);

            if ((updatedValue.toString().trim() != originalValueTaskGroup.toString().trim()) && !taskGroupEditSupportedTaskTypes.includes(taskTypeId)) {
              validationMessage = TemplateUIExcelInterface.getErrorMessage(impactedCellDetail, errorDetails);
            }
          return validationMessage;
        },
      },
      {
        CellHeader: labels.customizedDescription,
        CellId: "CustomizedDescription",
        dataType: "richText",
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          wrapText: true,
          requiredColumnWidth: 278.27,
        },
         getCellData: (data) => {
          
          return Utility.getFormatedDescriptionToExcelFormat(data?.taskDetail ?? "");
        },
      },
      {
        CellHeader: labels.taskTags,
        CellId: "Tags",
        referenceData: {
          sourceDataObjectName: "TagsreferenceData",
          showDynamicDropdown: true,
          delimiter: "; ",
          referenceDataCellNameStartAddress: "L",
          referenceDataCellNameEndAddress: "P",
          referenceDataCellRowStartIndex: 5,
          referenceDataCellRowIndexMax: 1000,
          outputDataattributes: ["value", "tagGroup", "tag", "color", "id"],
        },
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          requiredColumnWidth: 140.93,
          wrapText: true,
        },
        CellData: {
        dataAttributeName: "engagementTagName",
        sourceDataAttributeName: "tagsList",
        seprator: "; ",
        dataType: "list",
        dataMode: "concatenate",
        cellDataTemplate: "",
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const tagsList = data?.tagsList;

          let taskTags = "";

          tagsList.length > 0 &&
            tagsList.forEach((tag, index) => {
              const matchingGroup = referenceData?.tags?.find((group) => group[4] == tag.engagementTagId);
              if (matchingGroup) {
                taskTags += matchingGroup[0];
                if (index < tagsList.length - 1) {
                  taskTags += "; ";
                }
              }
            });

          return taskTags;
        },
      },
      {
        CellHeader: labels.picSignOffRequired,
        CellId: "PicUserSignOffRequired",
        cellToBindDropDown: true,
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.YesNoTypes : currentResource.YesNoTypes;
          },
        },
        CellFormat: {
          locked: false,
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
          lockedCondition: {
            dataAttributeName: "isEPSignoffRequired",
          },
        },
        getCellData: (data) => {
          if (data.isEPSignoffRequired == true) {
            return labels.yes;
          }
          return data.isEPSignoffUserRequired === true ? labels.yes : labels.no;
        },
        validateImpactedCells: (updatedValue, validateRule, rowData, referenceData, rowInputPayload) => {
          let validationMessage = null;
          const errorDetails = {
            errorCode: 5203,
            defaultMessage: "PIC sign-off is required", // Use label from errors
          };

          const impactedCellDetail = this.columns.find((x) => x.CellId == "isEPSignoffRequired");
          let updatedValueImpactedCell = rowData[impactedCellDetail.CellDisplayIndex];

          if (updatedValueImpactedCell == "Yes" && updatedValue == labels.no) {
            validationMessage = TemplateUIExcelInterface.getErrorMessage(impactedCellDetail, errorDetails);
          }
          return validationMessage;
        },
      },

      {
        CellHeader: labels.eqrSignOffRequired,
        CellId: "EqrUserSignOffRequired",
        cellToBindDropDown: true,
        referenceData: {
          getCellData: (userLanguage) => {
            return userLanguage ? userLanguage.YesNoTypes : currentResource.YesNoTypes;
          },
        },
        CellFormat: {
          locked: false,
          lockedCondition: {
            dataAttributeName: "isEQRSignoffRequired",
          },
          RowsFillColor: ExcelColorValue.White,
          horizontalAlignment: "Left",
        },
        getCellData: (data) => {
          if (data.isEQRSignoffRequired === true) {
            return labels.yes;
          }
          return data.isEQRSignoffUserRequired === true ? labels.yes : labels.no;
        },
        validateImpactedCells: (updatedValue, validateRule, rowData, referenceData, rowInputPayload) => {
          let validationMessage = null;
          const errorDetails = {
            errorCode: 5204,
            defaultMessage: "EQR sign-off is required",
          };

          const impactedCellDetail = this.columns.find((x) => x.CellId == "isEQRSignoffRequired");
          let updatedValueImpactedCell = rowData[impactedCellDetail.CellDisplayIndex];

          if (updatedValueImpactedCell == "Yes" && updatedValue == labels.no) {
            validationMessage = TemplateUIExcelInterface.getErrorMessage(impactedCellDetail, errorDetails);
          }
          return validationMessage;
        },
      },

      {
        CellHeader: labels.prefix + " ",
        CellId: "originalTaskPrefix",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          return data.taskNamePrefix;
        },
      },
      {
        CellHeader: labels.requiredTitle+" ",
        CellId: "originalTaskTitle",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          adjustColumnWidth: true,
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          return data.isTaskNameEditable ? data.name : data.knowledgeTaskTitle;
        },
      },
      {
        CellHeader: labels.suffix + " ",
        CellId: "originalTaskSuffix",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          horizontalAlignment: "Left",
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          return data.taskNameSuffix;
        },
      },
      {
        CellHeader: labels.taskType,
        CellId: "taskType",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return currentResource.taskTypeAbbreviation[data.typeId];
        },
      },
      {
        CellHeader: labels.auditPhase,
        CellId: "auditPhase",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return currentResource.filterAuditPhases[data.auditPhaseId];
        },
      },
      {
        CellHeader: labels.milestone,
        CellId: "milestone",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return currentResource.milestonesLabels[data.timePhaseTypeId];
        },
      },
      {
        CellHeader: labels.timePhaseRequired + " ",
        CellId: "originalTimePhase",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          return data.periodName;
        },
      },
      {
        CellHeader: labels.taskGroupRequired + " ",
        CellId: "originalTaskGroup",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },

        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const taskSectionId = data?.taskSectionId;

          const matchingGroup = referenceData?.taskGroups?.find((group) => group[2] == taskSectionId);
          return matchingGroup ? matchingGroup[0] : "";
        },
      },
      {
        CellHeader: labels.customizedDescription + " ",
        CellId: "originalDescription",
        dataType: "richText",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          wrapText: true,
          requiredColumnWidth: 278.27,
        },
        getCellData: (data) => {
          return Utility.getInnerTextFromRichText(data?.taskDetail ?? "");
        },
      },
      {
        CellHeader: labels.taskTags + " ",
        CellId: "originalTags",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          requiredColumnWidth: 140.93,
          wrapText: true,
        },

        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          const tagsList = data?.tagsList;

          let taskTags = "";

          tagsList.length > 0 &&
            tagsList.forEach((tag, index) => {
              const matchingGroup = referenceData?.tags?.find((group) => group[4] == tag.engagementTagId);
              if (matchingGroup) {
                taskTags += matchingGroup[0];
                if (index < tagsList.length - 1) {
                  taskTags += "; ";
                }
              }
            });
          return taskTags;
        },
      },
      {
        CellHeader: labels.picSignOffRequired + " ",
        CellId: "originalIsEPUserSignoffRequired",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          if (data.isEPSignoffRequired == true) {
            return labels.yes;
          }
          return data.isEPSignoffUserRequired === true ? labels.yes : labels.no;
        },
      },
      {
        CellHeader: labels.eqrSignOffRequired + " ",
        CellId: "originalIsEQRUserSignoffRequired",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
        },
        getCellData: (data) => {
          if (data.isEQRSignoffRequired == true) {
            return labels.yes;
          }
          return data.isEQRSignoffUserRequired === true ? labels.yes : labels.no;
        },
      },
      {
        CellHeader: labels.taskId,
        CellId: "taskId",
        IsIdAttribute: true,
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return data.id;
        },
      },
      {
        CellHeader: labels.picSignOffRequired + "    ",
        CellId: "isEPSignoffRequired",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          return data.isEPSignoffRequired ? "Yes" : "No";
        },
      },
      {
        CellHeader: labels.eqrSignOffRequired + "    ",
        CellId: "isEQRSignoffRequired",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
          disableDefaultFormatting: true,
        },
        getCellData: (data) => {
          return data.isEQRSignoffRequired ? "Yes" : "No";
        },
      },
      {
        CellHeader: labels.hash,
        CellId: "HashValue",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        HashAttribue: {
          HashCalculatedDataattributesName: [
            {
              CellId: "Prefix",
            },
            {
              CellId: "RequiredTitle",
            },
            {
              CellId: "Suffix",
            },
            {
              CellId: "TimePhaseRequired",
            },
            {
              CellId: "TaskGroupRequired",
            },
            {
              CellId: "CustomizedDescription",
            },
            {
              CellId: "Tags",
            },
            {
              CellId: "PicUserSignOffRequired",
            },
            {
              CellId: "EqrUserSignOffRequired",
            },
          ],
        },
        getCellData: (data, configuration, additionalData, labels, referenceData) => {
          let hashValue: string = "";
          hashValue = Utility.getHashValueForRow(this.columns, [], data, referenceData); // can be more then one
          return hashValue;
        },
      },

      {
        CellHeader: labels.statusId,
        CellId: "UploadStatusId",
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.Black,
          RowsFillColor: ExcelColorValue.GrayColor,
          columnHidden: true,
        },
        getCellData: (data) => {
          return `${UploadStatus.Downloaded}`;
        },
      },
    ];
    this.rowheader = [
      {
        CellHeader: labels.referenceOnly,
        DisplayRange: ["A1:A1", "L1:AB1"],
        CellFormat: {
          locked: true,
        },
      },
      {
        CellHeader: labels.columnsToUpdate,
        DisplayRange: ["B1:K1"],
        CellFormat: {
          locked: true,
          HeaderFillColor: ExcelColorValue.GrayColor,
        },
      },
    ];
  }
}
